import React, { useState } from 'react';
import styles from './BusinessAdvisory.module.scss';
import FilterTabsCommon from '../../../../components/common/FilterTabsCommon/FilterTabsCommon';
import { TabContent, TabPane } from 'reactstrap';
import SalesSummary from '../../../../components/SellerPortalComponents/BusinessAdvisoryTabs/SalesSummary/SalesSummary';
import TrafficNumber from '../../../../components/SellerPortalComponents/BusinessAdvisoryTabs/TrafficNumber/TrafficNumber';
import ProductsPromotions from '../../../../components/SellerPortalComponents/BusinessAdvisoryTabs/ProductsPromotions/ProductsPromotions';
import SalesSuggestions from '../../../../components/SellerPortalComponents/BusinessAdvisoryTabs/SalesSuggestions/SalesSuggestions';

const fiterTabs = [
    { id: '1', label: 'Sales Summary' },
    { id: '2', label: 'Number of Traffic' },
    { id: '3', label: 'Products and Promotions Effectiveness' },
    { id: '4', label: 'Suggestions to Increase Sales' },
];

const BusinessAdvisory = () => {
    const [activeTab, setActiveTab] = useState('1');

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Business Advisory</h4>

            <div className={styles.filterContainer}>
                <FilterTabsCommon
                    tabs={fiterTabs}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            </div>

            <div>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId='1'>
                        {activeTab === '1' && <SalesSummary />}
                    </TabPane>
                    <TabPane tabId='2'>
                        {activeTab === '2' && <TrafficNumber />}
                    </TabPane>
                    <TabPane tabId='3'>
                        {activeTab === '3' && <ProductsPromotions />}
                    </TabPane>
                    <TabPane tabId='4'>
                        {activeTab === '4' && <SalesSuggestions />}
                    </TabPane>
                </TabContent>
            </div>
        </div>
    )
}

export default BusinessAdvisory;